import { render, staticRenderFns } from "./GenDefinitionDetail.vue?vue&type=template&id=8b995c1c&scoped=true&"
import script from "./GenDefinitionDetail.vue?vue&type=script&lang=js&"
export * from "./GenDefinitionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b995c1c",
  null
  
)

export default component.exports